import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/pbatch_run/batch_run/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 's', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
        {text: 'S', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 10, type: 'status'},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'Customer', value: 'customer_order__customer__title', sortable: true, filterable: true, divider: true, width: 100},
        // {text: 'N', value: 'customer_order__notion_id', sortable: false, filterable: true, divider: false, width: 30},
        {text: 'Customer order', value: 'customer_order__title', sortable: true, filterable: true, divider: true, width: 300},
        // {text: 'N', value: 'notion_id', sortable: false, filterable: true, divider: false, width: 10},
        {text: 'year_week', value: 'year_week', sortable: false, filterable: true, divider: true, width: 70},
        // {text: 'Delivery date', value: 'delivery_date', sortable: true, filterable: true, divider: true, type: 'date', width: 30},
        {text: 'Lot size smd', value: 'lot_size_smd', sortable: true, filterable: true, divider: true, width: 50},
        {text: 'Lot size THT', value: 'lot_size_tht', sortable: true, filterable: true, divider: true, width: 50},
        {text: 'target_finish_date', value: 'target_finish_date', sortable: false, filterable: true, divider: true, width: 50, type: 'date'},
        // {text: 'target_finish_date_color', value: 'target_finish_date_color', sortable: false, filterable: true, divider: true, width: 50},
        // {text: 'smd_start_plan', value: 'smd_start_plan', sortable: true, filterable: true, divider: true, width: 50, type: 'date'},
        // {text: 'smd_end_plan', value: 'smd_end_plan', sortable: true, filterable: true, divider: true, width: 50, type: 'date'},
        {text: 'tht_start_plan', value: 'tht_start_plan', sortable: true, filterable: true, divider: true, width: 50, type: 'date'},
        // {text: 'tht_end_plan', value: 'tht_end_plan', sortable: true, filterable: true, divider: true, width: 50, type: 'date'},
        {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 60},
        {text: 'Remaining tasks', value: 'remaining_task', sortable: false, filterable: true, divider: true, width: 200},
        {text: 'ma_list', value: 'ma_list', sortable: false, filterable: true, divider: true, width: 250},
        // {text: 'QTY', value: 'quantity', sortable: true, filterable: true, divider: true, width: 40},
        // {text: 'S/N SMD', value: 'sn_smd', sortable: true, filterable: true, divider: true,},
        // {text: 'S/N THT', value: 'sn_tht', sortable: true, filterable: true, divider: true, width: 80},
        // {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        // {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        // {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
        {text: 'N', value: 'customer_order__notion_id', sortable: false, filterable: true, divider: false, width: 30},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['customer_order__title', 'year', 'week'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: false,
    },
    filterGroupSingle: [],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        PBatchRunTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}